require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/fn/get-iterator.js
// module id = 74
// module chunks = 0